import axios from "axios";

// DO NOT FORGET TO CHANGE THE URL TO THE PRODUCTION URL
const getOrder = async ({ orderNumber, email, fullName }) => {

    const accessories = [
        "Seal Skin Boat OB Engine Cover",
        "Disposable Steering Wheel Cover",
        "Extra Car Cover Straps 3-Pack",
        "Extra Boat Cover Straps 6-Pack",
        "Seal Skin Micro Fiber Cloth 3PACK",
        "Seal Skin Wheel And Tire Brush",
        "Extra Jet Ski Cover Straps 3-Pack",
        "Seal Skin Dry Bag",
        "Fits: All Boats with a Center Console",        
        "Extra Boat Cover Straps 12-Pack",
        "Seal Skin Headrest Trash",
        "Seal Skin Applicator Pads 2p",
        "Portable Waterproof Auto Trash Can",
        "Seal Skin 2Hook Steel Steering Wheel Lock Red",
        "Heavy Duty Windshield Sunshade",
        "Extendable Cleaning Duster",
        "Antenna Patch",
        "Seal Skin Supreme: 14 Mil Thickness",
        "8 Straps with Hooks 20$ and UPS 2nd Day Air $9.41",
        "6 Straps with Hooks",
        "6 Straps With Hooks",
        "Boat Folding Seat Cover",
        "Seal Skin Boat OB Engine Cover",
        "Extra Car Cover Straps 3-Pack",
        "Extra Boat Cover Straps 12-Pack",
        "Extra Boat Cover Straps 6-Pack",
        "Seal Skin Micro Fiber Cloth 3PACK",
    ]

    const filterAccessories = (orderItems) => {
        console.log('filtering accessories', orderItems);
        return orderItems.filter(item => !accessories.includes(item.title));
    }

    try {
        const orderName = orderNumber.replace('#', '');
        const response = await axios.get(`${process.env.GATSBY_PMS_URL}/api/v1/order/get_order`, {
            params: {
                order_name: orderName,
                email: email,
                fullName: fullName
            }
        });
        if (!response.data.order.error) {
            const filteredItems = filterAccessories(response.data.order.lineItems);
            response.data.order.lineItems = filteredItems || [];
        }
        return response.data;
    } catch (error) {
        console.error('Error fetching order:', error);
         throw error?.response?.data?.error || 'Something went wrong. Please try again.';
        // throw error;
    }
}


const sendSupportRequest = async (data) => {
    try {
        const response = await axios.post(`${process.env.GATSBY_PMS_URL}/api/v1/zendesk/create_ticket`, data);
        return response.data;
    } catch (error) {
        console.error('Error sending support request:', error);
        throw error;
    }
}


const uploadImage = async (image) => {
    const formData = new FormData();
    formData.append('image', image);
    try {
        const response = await axios.post(`${process.env.GATSBY_PMS_URL}/api/v1/assets/upload`, formData);
        return response.data;
    } catch (error) {
        console.error('Error uploading image:', error);
        throw error;
    }
}

export { getOrder, sendSupportRequest, uploadImage };